import React from "react";

import ChooseSubscriptionImage from "@common/assets/images/FTUX/billing-choose-subscription.png";
import PageStateView from "@common/components/PageStateView/components/PageStateView";
import { Spinner } from "@common/components/Spinner/Spinner";
import { SubscriptionState, useSubscriptionContext } from "@main/context/Subscription/SubscriptionContext";
import { ZeroAppsFeedbackView } from "@main/pages/shared/components/ZeroAppsView/ZeroAppsView";
import { RoutePaths } from "@main/router/config/routePaths";
import { generatePath, Outlet, useParams } from "react-router-dom";

export function UserFeedbackModulePage() {
  const { workspaceSlug } = useParams();
  const { state } = useSubscriptionContext();
  const buttonUrl = generatePath(RoutePaths.ADMINISTRATION_BILLING, { workspaceSlug: workspaceSlug ?? null });

  if (!state) return <Spinner />;

  switch (state) {
    case SubscriptionState.noApps:
      return <ZeroAppsFeedbackView />;
    case SubscriptionState.usageExceedsCurrentSubscription:
      return (
        <PageStateView
          title="Which plan & add-on to choose"
          subtitle="Your usage of Shake exceeds your current workspace subscription. You can always check your workspace numbers and pick the appropriate subscription."
          imageSrc={ChooseSubscriptionImage}
          button={{ url: buttonUrl, title: "See subscription options" }}
        />
      );
    case SubscriptionState.good:
      return <Outlet />;
  }
}
